// import { calcTargetItemSize } from './layoutHelper';
import { __assign } from "tslib";
export var createStyles = function (styles) {
    try {
        var parsedStyleParams = styles.jsonStyleParams
            ? JSON.parse(styles.jsonStyleParams)
            : {};
        var styleParams = __assign(__assign({}, styles), parsedStyleParams);
        return styleParams;
    }
    catch (e) {
        return {};
    }
};
//# sourceMappingURL=designedPresetGallery.js.map